import { useMemo } from 'react'
import DOMPurify from 'dompurify'

const useHTMLText = (text) => {
  return useMemo(() => {
    return DOMPurify.sanitize(text)
  }, [text])
}

export default useHTMLText